import { render, staticRenderFns } from "./UpdateContentManualStats.vue?vue&type=template&id=71f187d5&"
import script from "./UpdateContentManualStats.vue?vue&type=script&lang=js&"
export * from "./UpdateContentManualStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports